import { InvestigationTypesTranslations } from './types';

export const deInvestigationTranslations: InvestigationTypesTranslations = {
    BLOOD_CULTURE: "Kultur – Blutkultur",
    URINE_CULTURE: "Kultur – Urinkultur",
    SPUTUM_CULTURE: "Kultur – Sputumkultur",
    WOUND_CULTURE: "Abstrich – Wundabstrich",
    THROAT_CULTURE: "Abstrich – Rachen",
    GENITAL_CULTURE: "Abstrich – äußeres Genitale",
    PEAK_FLOW: "Peak Flow",
    URINE_DIPSTICK: "Urinstix",
    US_VENOUS_DUPLEX: "Ultraschall – Venöse Duplexsonographie",
    ECG: "EKG",
    US_TTE: "Ultraschall – Transthorakale Echokardiographie",
    CT_CHEST: "CT – Thorax",
    CT_ABDO: "CT – Abdomen",
    US_ABDO: "Ultraschall – Abdomen",
    US_TRANSVAGINAL: "Ultraschall – transvaginal",
    X_RAY_ABDO: "Röntgen – Abdomen",
    X_RAY_CHEST: "Röntgen – Thorax",
    PUNCTURE_PERITONEAL: "Punktion – Ascitespunktion",
    PUNCTURE_PLEURAL: "Punktion – Pleurapunktion",
    X_RAY_CATH_LAB: "Herzkatheter",
    CT_HEAD: "CT – Schädel",
    CT_AORTA: "CT Aorta",
    PUNCTURE_LUMBAR: "Punktion – Lumbalpunktion",
    US_THYROID: "Ultraschall – Schilddrüse",
    CTG: "CTG",
    DIX_HALLPIKE_MANEUVER: "Dix-Hallpike-Test",
    PREGNANCY_TEST: "Schwangerschaftstest",
    US_ARTERIAL_DUPLEX: "Ultraschall – Arterielle Doppler/Duplex-Untersuchung",
    ENDO_OGD: "Ösophago-Gastro-Duodenoskopie",
    US_TOE: "Ultraschall – Transösophageale Echokardiographie",
    X_RAY_FOOT_LEFT: "Röntgen – Fuß links",
    X_RAY_FOOT_RIGHT: "Röntgen – Fuß rechts",
    X_RAY_HIP_LEFT: "Röntgen – Hüfte links",
    X_RAY_HIP_RIGHT: "Röntgen – Hüfte rechts",
    X_RAY_KNEE_LEFT: "Röntgen – Knie links",
    X_RAY_KNEE_RIGHT: "Röntgen – Knie rechts",
    X_RAY_LONG_LEG_LEFT: "Röntgen – Ganzbeinstandaufnahme links",
    X_RAY_LONG_LEG_RIGHT: "Röntgen – Ganzbeinstandaufnahme rechts",
    X_RAY_LUMBAR: "Röntgen – LWS",
    X_RAY_PELVIS: "Röntgen – Hüftübersicht",
    X_RAY_ANKLE_LEFT: "Röntgen – Sprunggelenk links",
    X_RAY_ANKLE_RIGHT: "Röntgen – Sprunggelenk rechts",
    PUNCTURE_JOINT: "Punktion - Gelenk"
};